module.exports = __webpack_public_path__ + "static/assets/14db1428fa1036e12731b39dfb449a22.png";